import toast from "react-hot-toast";
import {BaseClient} from "../../Api/HttpClient";
import {error} from "ajv/lib/vocabularies/applicator/dependencies";

export const createContractTypeSlice = (set, get) => ({
    contractTypes: [],
    getAllContractTypes: async () => {
        await BaseClient().get(`/contract-types`)
            .then(response => {
                if (response.status === 200) {
                    set({contractTypes: response.data})
                    return response.data;
                } else {
                    toast.error(response.data);
                }
            })
    }
})